"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            minHeight: '100%',
        },
        content: {
            paddingBottom: theme.spacing(4),
        },
        floatingAction: {
            position: 'fixed',
            // this positioning could be customized in the future, see SnackbarOrigin
            bottom: 60,
            right: 60,
        },
    });
});
exports.default = useStyles;
